export default __webpack_public_path__ + "static/media/LearningHub.db58c6ee.svg";